import { log } from "@/utils/useLogger";
import { startAppListening } from "..";
import { canvasCopiedToClipboard } from "@/store/actions";
import { getBaseLayerBlob } from "@/utils/getBaseLayerBlob";
import { addToast } from "@/reducer/designslice";
import { copyBlobToClipboard } from "@/utils/utils";

const moduleLog = log.child({ namespace: "canvasCopiedToClipboardListener" });

export const addCanvasCopiedToClipboardListener = () => {
  startAppListening({
    actionCreator: canvasCopiedToClipboard,
    effect: async (action, { dispatch, getState }) => {
      const state = getState();

      const blob = await getBaseLayerBlob(state);

      if (!blob) {
        moduleLog.error("获取基础层blob时出现问题");
        dispatch(
          addToast({
            title: "复制画布时出现问题",
            description: "无法导出基础层",
            status: "error",
          })
        );
        return;
      }
      copyBlobToClipboard(blob);
      dispatch(
        addToast({
          title: "画布复制到剪贴板",
          status: "success",
        })
      );
    },
  });
};
